export enum ProductServiceProps{
    TOTAL_PAGES = 'totalPages',
    TOTAL_ITEMS = 'totalItems',
    CURRENT_PAGE = 'currentPage',
    DATA = 'data',
}